let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fBPHr")).then(() => parcelRequire('e2l8c'));